export default (props) => ({
  // liveOmit: true,
  omitExtraData: true,
  ...props,
});
